import { render, staticRenderFns } from "./simple-header-no-footer.vue?vue&type=template&id=7a49cf7c"
import script from "./simple-header-no-footer.vue?vue&type=script&lang=js"
export * from "./simple-header-no-footer.vue?vue&type=script&lang=js"
import style0 from "./simple-header-no-footer.vue?vue&type=style&index=0&id=7a49cf7c&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports